import { render } from "./Create.vue?vue&type=template&id=39ef4c30&scoped=true"
import script from "./Create.vue?vue&type=script&lang=js"
export * from "./Create.vue?vue&type=script&lang=js"

import "./Create.vue?vue&type=style&index=0&id=39ef4c30&scoped=true&lang=css"

import exportComponent from "D:\\VueLearning\\SheepbaseVueJs\\SheepBaseVueApp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39ef4c30"]])

export default __exports__